import React, { useState, useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { fetchSites, resetSiteSearch } from '../provider/actions';
import { Grid } from '@material-ui/core';
import { PlacesAutocomplete, Button } from 'components';
import WithInSelect from 'components/Input/Select';

const defaultRangeList = [
  { label: 'within 10 mi (15 km)', value: 10 },
  { label: 'within 25 mi (40 km)', value: 25 },
  { label: 'within 50 mi (80 km)', value: 50 },
  { label: 'within 100 mi (160 km)', value: 100 },
  { label: 'within 250 mi (400 km)', value: 250 },
  { label: 'Entire World', value: 35000 },
];
const defaultValue = 50;

const SiteSearch = (props) => {
  const {
    trial_id,
    language,
    fetchTrialSites,
    resetSearch,
    hasSearched,
    searchData,
    setSearchData,
    setHasSearched,
    rangeList = defaultRangeList,
    searchButtonLabel = 'Search',
    initialRadius,
    initialLocation,
    useBrowserLocation = false,
    showAllSites,
  } = props;

  const handleSearch = useCallback(
    (data) => {
      const { lat } = data;
      if (lat) {
        resetSearch();
        !hasSearched && setHasSearched(true);
        fetchTrialSites({ trial_id, language, ...data });
      } else {
        resetSearch();
        setHasSearched(false);
      }
    },
    [
      fetchTrialSites,
      resetSearch,
      trial_id,
      language,
      hasSearched,
      setHasSearched,
    ],
  );

  const handleLocationSelect = useCallback(
    ({ location, country, place }) => {
      const { lat = 0, lng = 0 } = location || {};
      const { country_code } = country || {};
      const locationData = { lat, lng, country: country_code, place: place };
      const data = {
        ...searchData,
        ...locationData,
      };
      setSearchData(data);
      if (lat) {
        hasSearched && handleSearch(data);
      } else {
        resetSearch();
        setHasSearched(false);
      }
    },
    [
      searchData,
      setSearchData,
      resetSearch,
      handleSearch,
      hasSearched,
      setHasSearched,
    ],
  );

  const handleRadiusSelect = useCallback(
    (value) => {
      const data = { ...searchData, radius: value };
      setSearchData(data);
      hasSearched && handleSearch(data);
      // resetSearch();
      // setHasSearched(false)
    },
    [searchData, hasSearched, handleSearch, setSearchData],
  );

  React.useEffect(() => {
    if (showAllSites) {
      fetchTrialSites({ trial_id, language, ...initialLocation });
    }
  }, []);

  return (
    <>
      <Grid item xs={12} sm>
        <PlacesAutocomplete
          APIkey="AIzaSyAJ5xOLytZDDRdeLzkZOKWrXiyKhkOVKfU"
          placeholder="Address, city or postal code"
          color="secondary"
          variant="filled"
          onSelect={handleLocationSelect}
          localHistory={true}
          browserLocation={useBrowserLocation}
          defaultValue={searchData.place}
          //   onChange = {}
          //   value = ""
          //   defaultOptions={}
          //   onRemoveDefaultOption = {handleRemoveDefaultOption}
        />
      </Grid>
      <Grid item xs={12} sm md={4}>
        <WithInSelect
          list={rangeList}
          defaultValue={initialRadius || defaultValue}
          onChange={handleRadiusSelect}
          value={searchData.radius}
          fullWidth
          // square
        />
      </Grid>
      {!hasSearched && (
        <Grid item>
          <Button
            variant="contained"
            // color="#2A95F3"
            // activeColor="#1A75C5"
            color="primary"
            size="large"
            // noShadow
            // component={RouterLink}
            // to="/search"
            onClick={() => handleSearch(searchData)}
            disabled={!searchData.lat || hasSearched}
            // square
            // todo from theme
          >
            {searchButtonLabel}
          </Button>
        </Grid>
      )}
    </>
  );
};

function mapStateToProps({ trial }) {
  return {
    trial_id: trial.id,
    language: trial.language,
    rangeList: trial.miles_list,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    fetchTrialSites: (obj) => dispatch(fetchSites(obj)),
    resetSearch: () => dispatch(resetSiteSearch()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SiteSearch);
